var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "template-default one-column-layout",
      style: _vm.fixed ? "" : "padding-top: 0!important"
    },
    [
      _c(
        "div",
        { staticClass: "top", style: _vm.fixed ? "" : "position: unset" },
        [
          _vm._t("top"),
          _vm._v(" "),
          _c(
            "div",
            {
              class:
                (_vm.isMobile ? "" : "container") +
                " component-navbar d-md-flex justify-content-md-between"
            },
            [
              _c("Logo"),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("h2", { staticClass: "mt-1" }, [_vm._v(_vm._s(_vm.title))])
                : _c("h3", { staticClass: "mt-2 text-right mr-2" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1" }, [_vm._t("header")], 2)
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("main", [_c("div", { staticClass: "pt-4" }, [_vm._t("default")], 2)])
      ]),
      _vm._v(" "),
      _c("footer", [_c("Footer")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74e182bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e182bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/OneColumLayout.vue
// module id = null
// module chunks = 